import React, { useEffect, useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import '../../styles/payments.css'
import LayoutWithAccountCard from '../../layout/Layout/layout-account-card'
import { MENU_OPTIONS } from '../../layout/Layout/menu-options'
import { Col, Row ,FormControl} from 'react-bootstrap'
import { accountsSelector, getMenuListSelector } from '../../selectors'
import { useSelector } from 'react-redux'
import PaymentsService from '../../services/payments.service'
import MenuCard from '../../layout/Navigation/menu-card'
import DynamicMenuCard from '../../layout/Navigation/DynamicCard'
import config from 'custom/config/environment'

export default function BillerServicesView() {
  const history = useHistory()
  const location = useLocation()
  const accounts = useSelector(accountsSelector) || []
  const [billerList, setBillerList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (location?.state === undefined || location?.state === null) {
      history.push('/payments/payBills')
      return
    }
    getBillProducts()
  }, [])

  const getBillProducts = useCallback(async () => {
    try {
      const { categoryDetails } = location.state
      const response = await PaymentsService.getAllBillers({
        fetchServices: true,
        fetchProducts: true,
      })
      if (response.status === 200) {
        let serviceDetails = response.data['categories'].filter(
          (ele) => ele.category === categoryDetails.category,
        )[0].services
        serviceDetails.forEach((element) => {
          element.title = element.serviceId
          element.desc = element.description
          element.icon = element.logo
          element.key = element.serviceId
        })
        setBillerList(serviceDetails)
      }
    } catch (err) {
    }
  }, [])

  const handleMenuCallback = useCallback((option) => {}, [])


  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const filteredBillerList = billerList.filter(biller =>
    biller.desc.toLowerCase().includes(searchTerm.toLowerCase())
  )


  return (
    <LayoutWithAccountCard breadCumKey='BILLER_SERVICES_VIEW'>
       <FormControl
        type="search"
        placeholder="Search School"
        className="mb-3"
        value={searchTerm}
        onChange={handleSearch}
      />
      <Row>
        {filteredBillerList.map((option, index) => (
          <DynamicMenuCard
            handleMenuCallback={() =>
              {
              history.push({
                pathname: (option.category === "SCHOOLPAY" && config.CLIENT_NAME === 'NBS')?'/payments/services/school/product':'/payments/services/product',
                state: { serviceDetails: option },
              })
            }
            }
            icon={option.icon}
            name={option.desc}
            description={''}
            key={index}
          />
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
